/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";
import Logo from "../../assets/png/logo_autoelevadores_echarri-removebg-preview.png";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LoginIcon from "@mui/icons-material/Login";
import { Link } from "react-router-dom";
import "./Navbar.css"; // Importar el CSS

const Navbar = ({
  setSectionAlquilerView,
  setSelectOptionAlquiler,
  categories,
  enterprise,
}) => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [menuActive, setMenuActive] = useState(false);
  const [alquilerMenuActive, setAlquilerMenuActive] = useState(false);
  const navRef = useRef(null); // Referencia para el menú

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    setIsSmallScreen(mediaQuery.matches);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSmallScreen]);

  const toggleMenu = () => {
    setMenuActive(!menuActive);
    if (!menuActive) setAlquilerMenuActive(false); // Asegúrate de cerrar el submenú al abrir el menú principal
  };

  const toggleAlquilerMenu = () => {
    setAlquilerMenuActive(!alquilerMenuActive);

    // Si no es una pantalla pequeña, desplazamos la vista
    if (!isSmallScreen) {
      const alquilerSection = document.getElementById("alquiler-section");
      if (alquilerSection) {
        alquilerSection.scrollIntoView({
          behavior: "smooth",
          block: "start", // Desplaza al principio de la sección
        });
      }
    }
  };

  const handleAlquilerClick = (option) => {
    setSectionAlquilerView(true); // Cambia a la vista de alquiler
    setSelectOptionAlquiler(option); // Pasa el valor seleccionado al componente CategoriaProductos
    setMenuActive(false); // Cerrar menú
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const closeMenu = () => {
    setMenuActive(false);
    setSectionAlquilerView(false);
    setAlquilerMenuActive(false);
  };

  // Detectar clics fuera del menú
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Verifica si el clic ocurrió fuera del menú
      if (
        navRef.current &&
        !navRef.current.contains(event.target) &&
        !event.target.closest(".categoria-productos")
      ) {
        // Si el clic es fuera del menú y no en la vista de productos, cierra el menú
        closeMenu();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [navRef, closeMenu]);

  return (
    <nav className="navbar" ref={navRef}>
      {/* Logo */}
      <div className="logo">
        <Link to="/" onClick={() => setSectionAlquilerView(false)}>
          <img
            src={enterprise?.logoUrl ? enterprise.logoUrl : Logo}
            alt="Logo de empresa"
            style={{ width: 200 }}
          />
        </Link>
      </div>

      {/* Menú */}
      <ul className={`nav-links ${menuActive ? "active" : ""}`}>
        <li>
          <a href="#empresa" onClick={() => closeMenu()}>
            Empresa
          </a>
        </li>
        {categories.length !== 0 && (
          <li onClick={toggleAlquilerMenu}>
            <span
              // eslint-disable-next-line no-script-url
              // href="javascript:void(0)"
              onClick={() => setSectionAlquilerView(false)}
            >
              Alquiler
            </span>
            {/* Submenú */}
            <ul
              className={`submenu ${
                alquilerMenuActive && menuActive ? "active" : ""
              }`}
            >
              {categories.map((c) => (
                <li
                  key={c?._id}
                  onClick={() => handleAlquilerClick(c)}
                  className="itemSubmenu"
                >
                  <span>{c.titulo}</span>
                </li>
              ))}
            </ul>
          </li>
        )}

        <li>
          <a href="#clientes" onClick={() => closeMenu()}>
            Clientes
          </a>
        </li>
        <li>
          <a href="#servicios" onClick={() => closeMenu()}>
            Servicios
          </a>
        </li>
        <li>
          <a href="#cotizacion" onClick={() => closeMenu()}>
            Cotización
          </a>
        </li>
        {isSmallScreen && (
          <>
            <div className={`iconsMenuSmall`}>
              <a rel="noreferrer" href="/login">
                <LoginIcon />
              </a>

              <a
                href="https://wa.me/1234567890"
                target="_blank"
                rel="noreferrer"
              >
                <WhatsAppIcon />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer">
                <InstagramIcon />
              </a>
            </div>
          </>
        )}
      </ul>

      {/* Iconos sociales */}
      <div className={`social-icons`}>
        <a rel="noreferrer" href="/login">
          <LoginIcon />
        </a>
        {/* <div className="redesSociales">
          <a
            href={`https://wa.me/${
              enterprise?.celular
                ? formatPhoneNumber(enterprise.celular)
                : "5491126485397"
            }`}
            target="_blank"
            rel="noreferrer"
          >
            <WhatsAppIcon />
          </a>
          <a
            href={
              enterprise?.instagram
                ? `https://www.instagram.com/${enterprise.instagram}/`
                : "https://www.instagram.com/autoelevadoresecharri/"
            }
            target="_blank"
            rel="noreferrer"
          >
            <InstagramIcon />
          </a>
        </div> */}
      </div>

      {/* Menú Hamburguesa */}
      <div className="hamburger-menu" onClick={toggleMenu}>
        ☰
      </div>
    </nav>
  );
};

export default Navbar;
